import { useMediaQuery } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import useTheme from '@material-ui/core/styles/useTheme';

export function useMediaQueryHandler(breakpoint: Breakpoint) {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint), { noSsr: true });
}

export function useMobile(breakpoint: Breakpoint = 'xs') {
  return useMediaQueryHandler(breakpoint);
}

export function useIPad() {
  return useMediaQueryHandler('md');
}
